import ReactLoading from "react-loading";
import styles from "./styles/Button.module.scss";
// Utils
import { rl20white } from "../../../utils/configs/react-loading";

const Button = ({
  children,
  color = "primary",
  disabled,
  isLoading,
  onClick,
  submit,
  className: inheritedClassName,
}) => {
  const className = `${styles.button} ${styles[color]} ${
    isLoading ? styles["is-loading"] : ""
  } ${disabled ? styles.disabled : ""} ${inheritedClassName || ""}`;

  return (
    <button
      type={!submit ? "button" : "submit"}
      className={className}
      onClick={!submit ? onClick : undefined}
      disabled={disabled}
    >
      {isLoading ? <ReactLoading {...rl20white} /> : children}
    </button>
  );
};

export default Button;
